import React from 'react'
import { Context as StoreContext } from './Store'
import { publicityCampaignsAPI, productPublicitiesAPI, extraCostsAPI, guidesAPI, stockCostsAPI, externalwarehousingCostsAPI, eventsAPI, groupedSalesAPI, liquidationsAPI, requisitionsAPI, salesChannelShippmentsAPI} from '../api'
import pagesIndex from '../pages-index'

export const Context = React.createContext({
	recall: null,
	setRecall: () =>{},
	current: null,
	guides: {
		guides: null,
		create: () => {},
		refresh: () => {},
		clean: () => {},
	},
	stockCosts: {
		stockCosts: null,
		create: () => {},
		detail: () => {},
		update: () => {},
		remove: () => {},
		clean: () => {},
	},
	extraCosts: {
		extraCosts: null,
		create: () => {},
		clean: () => {},
		remove: () => {},
		detail: () => {},
		update: () => {},
	},
	publicityCampaigns: {
		publicityCampaigns: null,
		create: () => {},
		createBulk: () => {},
		clean: () => {},
		remove: () => {},
		detail: () => {},
		update: () => {},
	},
	productPublicities: {
		productPublicities: null,
		createBulk: () => {},
		detail: () => {},
	},
	externalwarehousingCosts:{
		externalwarehousingCosts:  null,
		clean: () => {},
		create: () => {},
		createBulk: () => {},
		detail: () => {},
		update: () => {},
		remove: () => {},
	},
	events:{
		events: null,
		groupedSales: [],
		loading:  null,
		detail: () => {},
		uploadGroupedSale: () => {},
		removeGroupedSales: () => {},
		liquidations: () => {},
		requisitions: () => {},
		create: () => {},
		registerShippments: () => {},
		resetEvents: () => {},
	}
})

export const Provider = (props) => {
	const { neededData } = pagesIndex()
	const { store } = React.useContext(StoreContext)

	const [current, setCurrent] = React.useState(false)
	const [recall, setRecall] = React.useState(false)

	const [guides, setGuides] = React.useState([])
	const Guides = {
		guides,
		create: (guide) => {
			guidesAPI.create(guide, (createdGuide) => {
				setGuides([...guides, createdGuide])
			})
			setRecall(false)
		},
		refresh: () => guidesAPI.refresh(setGuides),
		clean: () => guidesAPI.clean(setGuides),
	}

	const [stockCosts, setStockCosts] = React.useState(null)
	const StockCosts = {
		stockCosts,
		create: (stockCost) => {
		
			if(stockCost.id) StockCosts.update(stockCost)
			else stockCostsAPI.create(stockCost, (createdStockCost) => {
					setStockCosts([...stockCosts, createdStockCost])
				})
			
			setRecall(false)
		},
		detail:(sc) => {
			setCurrent(sc)
		},
		update:(stockCost) => {
			stockCostsAPI.update(current.id, stockCost, (editedGuide) => {
				setStockCosts([...stockCosts.filter(sc => sc.id !== editedGuide.id), editedGuide])
			})
			setRecall(false)
		},
		remove: (scid) => {
			stockCostsAPI.delete(scid, () => {
				setStockCosts(stockCosts.filter(sc => sc.id !== scid))
			})
			setCurrent(false)
		},
		clean: () => stockCostsAPI.clean(setStockCosts),
	}

	const [extraCosts, setExtraCosts] = React.useState(null)
	const ExtraCosts = {
		extraCosts,
		create: (extraCost) => {
			extraCostsAPI.create(extraCost, (createdExtraCost) => {
				const _extraCosts = [...extraCosts, createdExtraCost]
				_extraCosts.sort(sortDate(true))
				setExtraCosts(_extraCosts)
			})
			setRecall(false)
		},
		clean: () => extraCostsAPI.clean(setExtraCosts),
		remove:(ecid) => {
			extraCostsAPI.delete(ecid, () => {
				setExtraCosts(extraCosts.filter(ec => ec.id !== ecid))
			})
			setCurrent(false)
		},
		detail:(ec) => {
			setCurrent(ec)
		},
		update: (extraCost) => {
			extraCostsAPI.update(current.id, extraCost, (editedExtraCost) => {
				setExtraCosts([...extraCosts.map(ec => ec.id === editedExtraCost.id?editedExtraCost:ec)])
			})
			setCurrent(false)
			setRecall(false)
		}
	}
	
	const [publicityCampaigns, setPublicityCampaigns] = React.useState(null)
	const PublicityCampaigns = {
		publicityCampaigns,
		createBulk:(data, cb, error) => {
			publicityCampaignsAPI.bulkCreate(data, (res) => {
				setPublicityCampaigns(res.pcs)
				cb(res.download)
			}, error)
		},
		create: (publicityCampaign) => {
			publicityCampaignsAPI.create(publicityCampaign, (createdPublicityCampaign) => {
				setPublicityCampaigns([...publicityCampaigns, createdPublicityCampaign])
			})
			setRecall(false)
		},
		clean: () => publicityCampaignsAPI.clean(setPublicityCampaigns),
		remove:(pcids) => {
			publicityCampaignsAPI.delete(pcids, () => {
				setPublicityCampaigns(publicityCampaigns.filter(sc => !pcids.includes(sc.id) ))
			})
			setCurrent(false)
		},
		detail:(pc) => {
			setCurrent(pc)
		},
		update: (campaign) => {
			publicityCampaignsAPI.update(current.id, campaign, (editedCampaign) => {
				setCurrent(false)
				setPublicityCampaigns([...publicityCampaigns.filter(sc => sc.id !== editedCampaign.id), editedCampaign])
			})
			setRecall(false)
		}
	}


	const [productPublicities, setProductPublicies] = React.useState(null)
	const ProductPublicies = {
		productPublicities,
		detail:(pp) => {
			setCurrent(pp)
		},
		createBulk:(data, cb, error) => {
			productPublicitiesAPI.bulkCreate(data, (res) => {
				setProductPublicies(res.pcs)
				cb(res.download)
			}, error)
		}
	}
	
	const [externalwarehousingCosts, setExternalWarehousingCosts] = React.useState(null)
	const ExternalWarehousingCosts = {
		externalwarehousingCosts,
		clean: () => externalwarehousingCostsAPI.clean(setExternalWarehousingCosts),
		createBulk: (data, cb, error)=> {
			externalwarehousingCostsAPI.create(data, (res) => {
				setExternalWarehousingCosts(res.whc)
				cb(res.download)
			}, error)
		},
		create: (externalwarehousingCost) => {
		
			if(externalwarehousingCost.id) ExternalWarehousingCosts.update(externalwarehousingCost)
			else externalwarehousingCostsAPI.create(externalwarehousingCost, (createdGuide) => {
					setExternalWarehousingCosts([...externalwarehousingCosts, createdGuide])
				})
			
			setRecall(false)
		},
		detail:(sc) => {
			setCurrent(sc)
		},
		update:(externalwarehousingCost) => {
			externalwarehousingCostsAPI.update(current.id, externalwarehousingCost, (editedGuide) => {
				setExternalWarehousingCosts([...externalwarehousingCosts.filter(sc => sc.id !== editedGuide.id), editedGuide])
			})
			setRecall(false)
		},
		remove: (scid) => {
			externalwarehousingCostsAPI.delete(scid, () => {
				setExternalWarehousingCosts(externalwarehousingCosts.filter(sc => sc.id !== scid))
			})
			setCurrent(false)
		},
	} 
	
	const [events, setEvents] = React.useState(null)
	const [groupedSales, setGroupedSales] = React.useState(null)
	const Events = {
		events,
		groupedSales,
		detail:(gs) => {
			setCurrent(gs)
		},
		uploadGroupedSale: (groupedSale) => {
			console.log({groupedSale})
			if(groupedSale._id) 
				groupedSalesAPI.update(groupedSale._id,groupedSale, (updatedGroupedSale) => {
					setGroupedSales(groupedSales.map(gs => gs._id === updatedGroupedSale._id?updatedGroupedSale:gs))
				})
			else 
				groupedSalesAPI.create(groupedSale, (createdGroupedSale) => {
					setGroupedSales([...groupedSales, createdGroupedSale])
				})
			
			setRecall(false)
		},
		removeGroupedSales: (gsid) => {
			groupedSalesAPI.remove(gsid, () => {
				setGroupedSales(groupedSales.filter(g => g._id !== gsid))
			})
		},
		liquidations: (data, cb, error) => {
			liquidationsAPI.create(data, (res) => {
				setEvents(res.salesChannelEvents)
				cb(res.download)
			}, error)
		},
		requisitions: (data, cb, error) => {
			requisitionsAPI.create(data, cb, error)
		},
		registerShippments: (data, cb, error) => {
			salesChannelShippmentsAPI.register(data, cb, error)
		},
		create:(data, cb, error) => {
			eventsAPI.create(data, cb, error)
		}
	} 

	
	React.useEffect(() => {
		if(neededData.publicityCampaigns.includes(window.location.pathname))
			publicityCampaignsAPI.list(setPublicityCampaigns)
		
		if(neededData.productPublicities.includes(window.location.pathname))
			productPublicitiesAPI.list(setProductPublicies)
		
		if(neededData.stockCosts.includes(window.location.pathname))
			stockCostsAPI.list(setStockCosts)
		
		if(neededData.extraCosts.includes(window.location.pathname))
			extraCostsAPI.list(setExtraCosts)
	
		if(neededData.externalwarehousingCosts.includes(window.location.pathname))
			externalwarehousingCostsAPI.list(setExternalWarehousingCosts)
		
		if(neededData.guides.includes(window.location.pathname))
			guidesAPI.list(setGuides)

		if(neededData.events.includes(window.location.pathname))
			eventsAPI.list(setEvents)
		
		if(neededData.groupedSales.includes(window.location.pathname))
			groupedSalesAPI.list(setGroupedSales)

	}, [store])
	
	return (
		<Context.Provider value={{
			setRecall,
			recall,
			current,
			guides:Guides,
			stockCosts:StockCosts,
			extraCosts:ExtraCosts,
			publicityCampaigns:PublicityCampaigns,
			productPublicities: ProductPublicies,
			externalwarehousingCosts:ExternalWarehousingCosts,
			events: Events,
		}}>
			{props.children}
		</Context.Provider>
	)
}

function sortDate (desc = false) {
	return (a, b) => (
		a.date < b.date?-1
		:a.date > b.date? 1
		: 0
	) * ( desc? -1: 1 )
}